import { ActionType, ComponentConfig } from "../services/types/ComponentTypes";

const MANPOWER_SUMMARY_ACTION = {
  ActionType: ActionType.MANPOWER_ALLOCATION,
  Action: { Action: "manpower_allocation" },
  tooltip: "Assign employees",
};

function patchSummaryListNode(node: any): any {
  if (!node || typeof node !== "object") return node;

  const type = String(node.componentType ?? node.ControlType ?? "").toLowerCase();
  if (type === "summarylist" || type === "summerylist") {
    const actions = Array.isArray(node.SummeryActions)
      ? [...node.SummeryActions]
      : [];
    const hasManpower = actions.some((a: any) => {
      const at = String(a?.ActionType ?? "").toUpperCase();
      const act = String(a?.Action?.Action ?? "").toLowerCase();
      return at === "MANPOWER_ALLOCATION" || act === "manpower_allocation";
    });
    if (!hasManpower) {
      actions.unshift(MANPOWER_SUMMARY_ACTION);
    }
    return { ...node, SummeryActions: actions };
  }

  const kids: any[] = Array.isArray(node.childComponents)
    ? node.childComponents
    : Array.isArray(node.ChildControls)
      ? node.ChildControls
      : [];
  if (kids.length === 0) return node;

  const patchedKids = kids.map(patchSummaryListNode);
  if (node.childComponents) {
    return { ...node, childComponents: patchedKids };
  }
  if (node.ChildControls) {
    return { ...node, ChildControls: patchedKids };
  }
  return node;
}

/** Ensures job card summary (screen 104) has Assign Employees action when API JSON omits it. */
export function patchJobcardSummaryScreenConfig(
  config: ComponentConfig[]
): ComponentConfig[] {
  return config.map((c) => patchSummaryListNode(c) as ComponentConfig);
}
